// extracted by mini-css-extract-plugin
export default {"paginationControls":"Pagination_paginationControls__y1oTg"};